// @flow
import type { Component } from "recompose"
import { withRouter as reactRouterHOC } from "react-router"

type Added = {|
  history: {
    push: string => void,
  },
  location: {
    search: string,
    pathname: string,
  },
|}

function withRouter<T>(
  C: Component<{ ...$Exact<T>, ...$Exact<Added> }>,
): Component<T> {
  return reactRouterHOC(C)
}

export default withRouter



// WEBPACK FOOTER //
// ./src/hoc/withRouter.js